export default {
  'talk.title': '對講組',
  'talk.btn.add': '新增組',
  'talk.btn.guard': '下載人員',
  'talk.table.name': '組名稱',
  'talk.input.name': '請輸入對講組名稱',
  'talk.download.nodata': '沒有要下載的設備信息，請先錄入設備再下載數據',
};
